export const getFixedImageUrl = (url: string | null | undefined): string | undefined => {
  if (!url) return undefined;
  // If it's a blob url (local offline image), keep it
  if (url.startsWith('blob:')) return url;
  
  // If it contains /uploads/, extract from /uploads/ to the end
  // This safely strips http://.../api/../uploads/ and returns absolute native path
  const uploadsIdx = url.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    return url.substring(uploadsIdx);
  }

  return url;
};

/**
 * Compresse une image client-side avant stockage/upload
 * Reduit la taille du fichier et les dimensions pour optimiser le quota Hostinger
 */
export const compressImage = async (file: File, maxWidth = 1200, maxHeight = 1200, quality = 0.7): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    // Si ce n'est pas une image, on ne compresse pas
    if (!file.type.startsWith('image/')) {
        return resolve(file);
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Calculer les nouvelles dimensions en gardant le ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('Could not get canvas context'));
        
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Canvas to Blob failed'));
            }
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = (e) => reject(new Error('Image loading failed'));
    };
    reader.onerror = (e) => reject(new Error('FileReader failed'));
  });
};
